import lazyRetry from './lazyLoader';
import Lazy from 'components/Lazy.tsx';
import { lazy } from 'react';
import { Navigate, useParams } from 'react-router-dom';

const WorkflowExecutionsView = Lazy(lazy(() => lazyRetry(() => import('views/workflows/WorkflowExecutionsView.tsx'))));

const ExecutionsRedirect = () => {
  const { projectId } = useParams();
  return <Navigate to={`/projects/${projectId}/workflow-executions`} replace />;
};

const ProjectWorkflowExecutionsRoutes = {
  path: '',
  children: [
    {
      path: 'workflow-executions',
      element: <WorkflowExecutionsView />,
    },
    {
      path: 'workflows/:workflowId/executions',
      element: <ExecutionsRedirect />,
    },
  ],
};

export default ProjectWorkflowExecutionsRoutes;
